import Vue from 'vue'
import PortalVue from 'portal-vue'
import VueMobileDetection from 'vue-mobile-detection'
import App from './App.vue'
import store from './store'
import router from './router'
import SignalR from './plugins/SignalRPlugin'
import Logs from './plugins/LogsPlugin'
import Exception from './plugins/ExceptionPlugin'

Vue.use(Logs)
Vue.use(Exception)
Vue.use(SignalR, process.env.VUE_APP_HUB_URL)

Vue.use(PortalVue)
Vue.config.productionTip = false
Vue.use(VueMobileDetection)

Vue.config.errorHandler = async (err, vm) => {
  await store.dispatch('logs/logError', {
    innerException: `Component - ${vm.$options.name}`,
    stackTrace: err.stack,
    message: err.message,
    level: 'Exception',
  })
  throw err
}

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
